import angular from 'angular';

const resizeDirective = /* @ngInject */ () => ({
	template: `
<div class="resize" ng-class="{'up' : right }">
<i ng-show="!expanded" class="fa fa-expand fa-lg" ng-click="resize()" uib-tooltip="Déplier"></i>
<i ng-show="expanded" class="fa fa-times fa-lg" ng-click="close()" uib-tooltip="Replier"></i>
</div>`,
	scope:    {
		expand:  '&',
		restore: '&',
	},
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {any} attribute
	 */
	link(scope, element, attribute) {
		scope.expanded = false;

		scope.right = attribute.class === 'right-corner';

		scope.resize = () => {
			scope.expanded = true;
			scope.expand();
			scope.$emit('exp-expand');
		};

		scope.close = () => {
			scope.expanded = false;
			scope.$emit('exp-close');
			scope.restore();
		};
	},
});

angular.module('app')
	.directive('resize', resizeDirective);
